import type React from "react";
import { type FC, MouseEvent } from "react";

interface InputClearButtonProps {
	onClear: (e: React.MouseEvent<HTMLButtonElement>) => void;
	dataTestID?: string;
}

const InputClearButton: FC<InputClearButtonProps> = ({ onClear, dataTestID }) => {
	const handleClearClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault(); // It prevents accidental form submission
		onClear(e);
	};

	return (
		<button
			onClick={handleClearClick}
			type="button"
			data-testid={dataTestID ?? "common-input-clear-button"}
			className="absolute right-[8px] top-[65%] -translate-y-1/2 z-0 p-0
           h-5 w-5 rounded-full bg-blue-600 flex items-center justify-center 
           cursor-pointer hover:bg-blue-600"
		>
			<span className="icon-close text-white text-sm font-bold"></span>
		</button>
	);
};

export default InputClearButton;
